var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SdzModal",
    {
      ref: "modal",
      attrs: {
        "close-icon": true,
        width: _vm.$isMobile() ? "400" : "550",
        "custom-class": "reprove-modal",
        "hide-confirm-button": "",
        "hide-cancel-button": "",
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "buttons",
          fn: function () {
            return [
              _c(
                "v-btn",
                {
                  staticClass: "mb-3",
                  attrs: { color: "primary", outline: "", flat: "", large: "" },
                  on: { click: _vm.close },
                },
                [_vm._v("\n      Cancelar\n    ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mb-3",
                  attrs: { color: "primary", large: "" },
                  on: { click: _vm.approve },
                },
                [_vm._v("\n      Sim, ajustes realizados\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "v-layout",
        {
          staticClass: "pt-5 pb-2 px-5",
          attrs: {
            "align-center": "",
            column: "",
            "justify-center": "",
            wrap: "",
          },
        },
        [
          _c("img", {
            staticClass: "mb-4",
            attrs: {
              src: require(`@/assets/images/icons/info.svg`),
              width: "70",
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "modal-title" }, [
            _vm._v("\n      Tem certeza que deseja revisar essa nota?\n    "),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "modal-text" }, [
            _vm._v(
              "\n      O serviço de validação da nota ja deve ter sido ajustado para que o usuario possa receber os dados atualizados.\n    "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }